module.exports = __webpack_public_path__ + "static/media/letalk-small-logo-white.5dfd39a2.svg";